import { render, staticRenderFns } from "./footer_widget.vue?vue&type=template&id=5148cca7&scoped=true&lang=pug"
import script from "./footer_widget.vue?vue&type=script&lang=js"
export * from "./footer_widget.vue?vue&type=script&lang=js"
import style0 from "./footer_widget.vue?vue&type=style&index=0&id=5148cca7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5148cca7",
  null
  
)

export default component.exports